// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Statistics_wrapper__2uGRx","wrapperData":"Statistics_wrapperData__1k1JS"};